var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapLayersHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1282 153.98L232.034 252.968C243.337 258.651 256.663 258.651 267.966 252.968L464.872 153.98C476.566 148.101 476.639 131.434 464.997 125.453L268.279 24.3905C256.806 18.4963 243.194 18.4963 231.721 24.3905L35.0032 125.453C23.3614 131.434 23.4344 148.101 35.1282 153.98Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.111 276.375L94.9212 210.691C90.8894 208.687 86.1402 208.745 82.1584 210.846L31.2258 237.718C21.123 243.049 21.3118 257.582 31.5496 262.648L231.778 361.73C242.947 367.257 256.055 367.263 267.229 361.745L467.536 262.828C477.854 257.733 477.96 243.057 467.716 237.813L414.825 210.738C410.85 208.703 406.142 208.686 402.153 210.694L271.833 276.263C257.774 283.337 241.205 283.378 227.111 276.375Z",
    fill: "#D3D3D3",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.111 386.875L94.9212 321.191C90.8894 319.187 86.1402 319.245 82.1584 321.346L31.2258 348.218C21.123 353.549 21.3118 368.082 31.5496 373.148L231.778 472.23C242.947 477.757 256.055 477.763 267.229 472.245L467.536 373.328C477.854 368.233 477.96 353.557 467.716 348.313L414.825 321.238C410.85 319.203 406.142 319.186 402.153 321.194L271.833 386.763C257.774 393.837 241.205 393.878 227.111 386.875Z",
    fill: "#D3D3D3",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapLayersHighlight);
export default __webpack_public_path__ + "static/media/ico_map_layers_highlight.3ebae90ceb47e40def55d1fdde157bd6.svg";
export { ForwardRef as ReactComponent };